import { Col, Form, Input, Row} from "antd";
import React from 'react';
import {compose} from "redux";
import {translate} from 'react-i18next';
import _ from "lodash";
import { MARGIN_MD, PADDING_MD, SPAN_HALF } from "../../../../../styles/constants";
import uuidv4 from "uuid";

const formItemStyle = {
  width: "100%"
};
const colStyle = {
  paddingRight: PADDING_MD,
};


const mapPropsToFields = ({value: Annotation}) => ({
  Id: Form.createFormField({value: Annotation ? Annotation.Id : null}),
  Type: Form.createFormField({value: Annotation ? Annotation.Type : null}), 
  TimePeriodStart: Form.createFormField({value: Annotation ? Annotation.TimePeriodStart : null}),
  TimePeriodEnd: Form.createFormField({value: Annotation ? Annotation.TimePeriodEnd : null}), 
  LastNObservation: Form.createFormField({value: Annotation ? Annotation.LastNObservation : null}),
  LastNPeriod: Form.createFormField({value: Annotation ? Annotation.LastNPeriod : null}),
});

const onFieldsChange = (props, fields) => {
  const newValue = _.cloneDeep(props.value);
  props.onChange(props.name,  _.merge(newValue, _.mapValues(fields, ({value}) => value)));
}

const name = `id_${uuidv4()}`;

const DefaultAnnotationForm = ({
                          t,
                          form,
                          label
                        }) =>

  <Form className="advanced-form">
    <Row style={{marginBottom: 0}}>
      {label}:
    </Row>
    <Row style={{marginBottom: MARGIN_MD}}>
      <Col span={SPAN_HALF} style={colStyle}>
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.id.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('Id')(<Input />)}
        </Form.Item>
      </Col>
      <Col span={SPAN_HALF} style={colStyle} >
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.type.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('Type')(<Input />)}
        </Form.Item> 
      </Col>
    </Row>  
    <Row style={{marginBottom: MARGIN_MD}}>
      <Col span={SPAN_HALF} style={colStyle}>
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.default.timePeriodStart.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('TimePeriodStart')(<Input />)}
        </Form.Item>
      </Col>
      <Col span={SPAN_HALF} style={colStyle} >
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.default.timePeriodEnd.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('TimePeriodEnd')(<Input />)}
        </Form.Item> 
      </Col>
    </Row> 
    <Row style={{marginBottom: MARGIN_MD}}>
      <Col span={SPAN_HALF} style={colStyle}>
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.default.lastNObservation.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('LastNObservation')(<Input />)}
        </Form.Item>
      </Col>
      <Col span={SPAN_HALF} style={colStyle} >
        <Form.Item
          className="form-item-required"
          label={t('data.nodesConfig.annotations.annotation.default.lastNPeriod.label')}
          style={formItemStyle}
          labelAlign="left"
        >
          {form.getFieldDecorator('LastNPeriod')(<Input />)}
        </Form.Item> 
      </Col>
    </Row>  
           
  </Form>

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange, name})
)(DefaultAnnotationForm);
